import { useMutation } from '@tanstack/react-query'
import type { AxiosError } from 'axios'
import { resendVerificationApiV1AuthResendVerificationPost } from '@/common/api/client/sdk.gen'
import type {
    ResendVerificationApiV1AuthResendVerificationPostError,
    ResendVerificationApiV1AuthResendVerificationPostResponse,
    ResendVerificationRequest,
} from '@/common/api/client/types.gen'
import { useOptionalToast } from '@/common/ui/Toast/toastContext'

export const useResendVerificationModel = () => {
    const toast = useOptionalToast()

    const mutation = useMutation<
        ResendVerificationApiV1AuthResendVerificationPostResponse,
        AxiosError<ResendVerificationApiV1AuthResendVerificationPostError>,
        ResendVerificationRequest
    >({
        mutationFn: data => resendVerificationApiV1AuthResendVerificationPost({ body: data }).then(res => res.data!),
        onSuccess: () => {
            toast?.showToast({ type: 'success', message: 'Письмо с подтверждением отправлено' })
        },
        onError: () => {
            toast?.showToast({ type: 'error', message: 'Не удалось отправить письмо' })
        },
    })

    const handleResendVerification = (email: string) => {
        if (!email.trim()) return
        mutation.mutate({ email })
    }

    return {
        handleResendVerification,
        isPending: mutation.isPending,
        isSuccess: mutation.isSuccess,
        isError: mutation.isError,
        error: mutation.error,
    }
}
